import { Skeleton } from '@paulownia/shared/components/ui/skeleton';

function ProductCardSkeleton() {
    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 flex gap-4 items-start">
            {/* Image placeholder */}
            <Skeleton className="w-20 h-20 rounded-lg flex-shrink-0" />

            {/* Content */}
            <div className="flex-1 min-w-0 space-y-2">
                <div className="flex items-start justify-between gap-2">
                    <Skeleton className="h-5 w-32" />
                    <Skeleton className="h-5 w-16" />
                </div>
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
            </div>
        </div>
    );
}

function SectionSkeleton() {
    return (
        <div className="space-y-4">
            {/* Section title */}
            <Skeleton className="h-7 w-28" />

            {/* Product cards grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <ProductCardSkeleton />
                <ProductCardSkeleton />
                <ProductCardSkeleton />
                <ProductCardSkeleton />
            </div>
        </div>
    );
}

export function OrderPageSkeleton() {
    return (
        <div className="min-h-screen bg-gray-50 pb-24">
            {/* Header skeleton */}
            <div className="sticky top-0 z-30 bg-white border-b px-4 py-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Skeleton className="h-8 w-8 rounded" />
                        <Skeleton className="h-6 w-40" />
                    </div>
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-8 w-8 rounded-full" />
                        <Skeleton className="h-8 w-8 rounded-full" />
                    </div>
                </div>
            </div>

            {/* Section tabs skeleton */}
            <div className="sticky top-[57px] z-20 bg-white border-b">
                <div className="flex gap-2 px-4 py-2 overflow-hidden">
                    <Skeleton className="h-8 w-20 rounded-full" />
                    <Skeleton className="h-8 w-24 rounded-full" />
                    <Skeleton className="h-8 w-16 rounded-full" />
                    <Skeleton className="h-8 w-28 rounded-full" />
                </div>
            </div>

            {/* Products sections skeleton */}
            <div className="px-4 py-4 space-y-8">
                <SectionSkeleton />
                <SectionSkeleton />
            </div>
        </div>
    );
}
